import TurmasIndexPage from "@/Pages/Turmas/index.vue";
import NewEditTurmaPage from "@/Pages/Turmas/NewEditTurmaPage.vue";
import TurmasViewPage from "@/Pages/Turmas/view.vue";
import TurmasDashboard from "@/Pages/Turmas/dashboard.vue";
import TurmasBolsaFamilia from "@/Pages/Turmas/TurmasBolsaFamilia.vue";
import { can } from "@/plugins/can";

export default [
  {
    path: "/turmas/",
    name: "turmas",
    component: TurmasIndexPage,
  },
  {
    path: "/turmas/create",
    name: "turmas.create",
    component: NewEditTurmaPage,
    props: { editing: false },
  },
  {
    path: "/turmas/edit/:turma_id",
    name: "turmas.edit",
    component: NewEditTurmaPage,
    props: { editing: true },
  },
  {
    path: "/turmas/view/:turma_id",
    name: "turmas.view",
    component: TurmasViewPage,
  },
  {
    path: "/turmas/:id/metricas",
    name: "turmas.dashboard",
    component: TurmasDashboard,
  },
  {
    path: "/turmas/:id/bolsa-familia",
    name: "turmas.bolsa_familia",
    component: TurmasBolsaFamilia,
    beforeEnter(to, from, next) {
      if (!can(["bolsaFamilia.index"])) {
        return next({ name: "NaoAutorizado" });
      }
      return next();
    },
  },
];
